/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import translation from '../../../../../commons/translation';
import { Tag, Popconfirm, Tooltip, Input,Button } from 'antd';

import { getFieldDataWorkOrdersList, deleteWorkOrder } from '../../../Utils/FormCalls';
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';

const FieldDataMeasurementList = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const config = {
    viewTypes: ['card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['WorkOrder'],
    firstTitle: 'WorkOrder',
    secondTitle: 'CreatedBy',
    thirdTitle: 'RecordedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/FieldDataMeasurementDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getFieldDataWorkOrdersList();
      setDataSource(dataSource);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          
          style={{ width: 90, marginRight: 8, }}
        >
          {translation(translationCache, `Search`)}
        </SearchOutlined>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const edit = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const deleteById = async (id) => {
    await deleteWorkOrder(id);
    const dataSource = await getFieldDataWorkOrdersList();
    setDataSource(dataSource);
  };

  const columns = [
    {
      title: translation(translationCache, constant.WorkOrder),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder',
      ...getColumnSearchProps('WorkOrder')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(translationCache, constant.status),
      dataIndex: 'Status',
      key: 'Status',
      render: (text) => (
        <Tag
          color={
            text && text === 'Active' ? '#87d068' : text === 'Inactive' ? '#ff4d4f' : 'gold'
          }
          key={text}
        >
          {text}
        </Tag>
      )
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Tooltip placement="top" key="edit" title="Edit">
            <Button
              disabled={record.Status === 'Inactive'}
              style={{ marginRight: '5px' }}
              onClick={() => edit(record)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure that you want to delete the FieldDataMeasurement"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteById(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip placement="top" key="delete" title="Delete">
              <Button>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <ListView
      {...props}
      columns={columns}
      dataSource={dataSource}
      config={config}
      delete={deleteById}
    />
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(FieldDataMeasurementList);